<!-- 由 suu 创建于 2022-09-01 星期四 -->
<template>
  <div class="sum-meal-card">
    <!-- 满分 扣分都有值 -->
    <template v-if="info.fullMark.length && info.deductPoint.length">
      <div class="card-all">
        <div class="a-item a-left">
          <div class="i-vs">VS</div>
          <div class="i-title">扣分餐卡</div>
          <div class="i-imgs" v-if="info.deductPoint.length >= 4">
            <img
              class="img-item"
              v-for="(item, index) in info.deductPoint.slice(0, 4)"
              :key="index"
              :src="item"
              alt=""
            />
          </div>
          <img v-else :src="info.deductPoint[0]" alt="" class="i-img-one" />
        </div>
        <div class="a-item a-right">
          <img
            class="i-icon"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-diet-icon"
            alt=""
          />
          <div class="i-title">满分餐卡</div>
          <div class="i-imgs" v-if="info.fullMark.length >= 4">
            <img
              class="img-item"
              v-for="(item, index) in info.fullMark.slice(0, 4)"
              :key="index"
              :src="item"
              alt=""
            />
          </div>
          <img v-else :src="info.fullMark[0]" alt="" class="i-img-one" />
        </div>
      </div>
      <!-- 扣分原因 -->
      <div class="card-deduct-desc">
        <div class="dd-yys">
          <img
            class="y-img"
            :src="
              $parent.info.comprehensiveData.coachDetail.c_img +
              '?x-oss-process=image/resize,m_lfit,h_200,w_200'
            "
            alt=""
          />
          <div class="y-name">{{
            $parent.info.comprehensiveData.coachDetail.c_name
          }}</div>
          <!-- 图标 -->
          <img
            class="dd-yys-icon"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-diet-exp"
            alt=""
          />
        </div>
        <div class="dd-title">是什么导致我们的餐卡扣分呢？</div>
        <div class="dd-cent">
          在这周的饮食中：<br />
          <template v-for="(item, index) in info.deductPointDetail">
            <div
              class="c-item"
              v-if="item.list && item.list.length"
              :key="index"
            >
              {{ item.title }}出现：<span>{{ item.list.join('、') }}</span>
            </div>
          </template>
          原来是它们影响了你的饮食！相信宝贝下周一定会做得更好！
        </div>
        <div class="dd-title">一周优秀餐卡集锦</div>
        <div class="dd-more-text"
          >虽然偶尔有扣分，但宝贝也在一点点改善，通过每天的学习获得了满分餐卡，让我们一起看看本周的满分餐卡集锦吧！</div
        >
        <div class="dd-more-imgs-region">
          <div class="dd-more-imgs">
            <img
              :src="item"
              v-for="(item, index) in info.fullMark"
              :key="index"
              alt=""
              class="img-item"
            />
          </div>
        </div>
      </div>
    </template>
    <!-- 只有满分 没有扣分 -->
    <template v-if="info.fullMark.length && !info.deductPoint.length">
      <div class="card-only">
        <div class="on-top">
          <div class="on-title">满分餐卡</div>
          <img
            class="on-icon"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-diet-icon"
            alt=""
          />
          <div class="on-more-imgs-region">
            <div class="on-more-imgs">
              <img
                :src="item"
                v-for="(item, index) in info.fullMark"
                :key="index"
                alt=""
                class="img-item"
              />
            </div>
          </div>
        </div>
        <div class="on-yys">
          <img
            class="y-img"
            :src="
              $parent.info.comprehensiveData.coachDetail.c_img +
              '?x-oss-process=image/resize,m_lfit,h_200,w_200'
            "
            alt=""
          />
          <div class="y-name">{{
            $parent.info.comprehensiveData.coachDetail.c_name
          }}</div>
          <!-- 图标 -->
          <img
            class="on-yys-icon"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-diet-exp"
            alt=""
          />
        </div>
        <div class="on-more-title">满分餐卡总结</div>
        <div class="on-more-text"
          >学习营养知识、坚持饮食打卡，看似不起波澜的日复一日，会在某一天让我们看到坚持的意义。加油！期待宝贝下一周的满分打卡。</div
        >
      </div>
    </template>
    <!-- 只有扣分 没有满分 -->
    <template v-if="!info.fullMark.length && info.deductPoint.length">
      <div class="card-only card-only-deduct">
        <div class="on-top">
          <div class="on-title">扣分餐卡</div>
          <img
            class="on-icon"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-diet-icon"
            alt=""
          />
          <div class="on-more-imgs-region">
            <div class="on-more-imgs">
              <img
                :src="item"
                v-for="(item, index) in info.deductPoint"
                :key="index"
                alt=""
                class="img-item"
              /> </div
          ></div>
        </div>
        <div class="on-yys">
          <img
            class="y-img"
            :src="
              $parent.info.comprehensiveData.coachDetail.c_img +
              '?x-oss-process=image/resize,m_lfit,h_200,w_200'
            "
            alt=""
          />
          <div class="y-name">{{
            $parent.info.comprehensiveData.coachDetail.c_name
          }}</div>
          <!-- 图标 -->
          <img
            class="on-yys-icon"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-diet-exp"
            alt=""
          />
        </div>
        <div class="on-more-title">是什么导致我们的餐卡扣分呢？</div>
        <div class="on-more-cent">
          在这周的饮食中：<br />
          <template v-for="(item, index) in info.deductPointDetail">
            <div
              class="c-item"
              v-if="item.list && item.list.length"
              :key="index"
            >
              {{ item.title }}出现：<span>{{ item.list.join('、') }}</span>
            </div>
          </template>
          原来是它们影响了你的饮食！相信宝贝下周一定会做得更好！
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'sum-meal-card',

  components: {},

  props: {
    info: {}
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.sum-meal-card {
  width: 100%;
  box-sizing: border-box;
  margin-top: 15px;
  .card-all {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    overflow: hidden;
    position: relative;
    .a-item {
      flex: 1;
      box-sizing: border-box;
      padding: 14px;
      padding-top: 25px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: linear-gradient(169deg, #e7e0ff 0%, #f9f9ff 100%);
      .i-title {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 26px;
      }
      .i-imgs {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        // margin-left: -4px;
        .img-item {
          width: 62px;
          height: 62px;
          object-fit: cover;
          // margin-right: 4px;
          margin-bottom: 4px;
          border-radius: 4px;
        }
      }
      .i-img-one {
        width: 128px;
        height: 128px;
        box-sizing: border-box;
        border-radius: 6px;
        object-fit: cover;
        margin-bottom: 4px;
      }
    }
    .a-right {
      background: linear-gradient(180deg, #f8cae6 0%, #fffeff 100%);
      .i-icon {
        width: vw(40);
        position: absolute;
        top: 2px;
        right: 8px;
      }
    }
    .i-vs {
      width: 42px;
      height: 42px;
      box-sizing: border-box;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: 'DIN';
      font-weight: bold;
      color: #b09dfc;
      border: 6px solid #f5f2ff;
      border-radius: 50%;
      position: absolute;
      top: 12px;
      left: 50%;
      transform: translateX(-50%);
      font-style: italic;
      padding-right: 4px;
      // padding-top: 7px;
    }
  }
  .card-deduct-desc {
    width: 100%;
    box-sizing: border-box;
    padding-top: 18px;
    background: #fff;
    .dd-yys {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding: 0 20px;
      position: relative;
      .y-img {
        width: 42px;
        height: 43px;
        background: #e5e5e5;
        border-radius: 12px;
      }
      .y-name {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        margin-left: 10px;
      }
      .dd-yys-icon {
        width: 51px;
        position: absolute;
        right: 14px;
      }
    }
    .dd-title {
      width: 100%;
      box-sizing: border-box;
      height: 31px;
      background: rgba($color: #6236ff, $alpha: 0.08);
      display: flex;
      align-items: center;
      padding-left: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      margin-top: 20px;
    }
    .dd-cent {
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;
      // padding-right: 22px;
      margin-top: 15px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 20px;
      color: rgba($color: #000, $alpha: 0.7);
      word-break: break-all;
      span {
        color: rgba($color: #6236ff, $alpha: 0.7);
        font-weight: 600;
      }
      .c-item {
        margin-bottom: 4px;
      }
    }
    .dd-more-text {
      font-size: 12px;
      font-weight: 400;
      color: #000000;
      line-height: 20px;
      margin-top: 15px;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .dd-more-imgs-region {
      width: 100%;
      box-sizing: border-box;
      overflow-x: auto;
      .dd-more-imgs {
        width: fit-content;
        box-sizing: border-box;
        padding: 0 20px;
        display: flex;
        align-items: center;
        margin-top: 9px;
        .img-item {
          width: 100px;
          height: 100px;
          object-fit: cover;
          border-radius: 6px;
          margin-right: 8px;
        }
      }
    }
  }
  .card-only {
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    .on-top {
      width: 100%;
      box-sizing: border-box;
      height: 164px;
      background: linear-gradient(180deg, #f8cae6 0%, #fef3fc 100%);
      border-radius: 8px 8px 0px 0px;
      padding: 20px;
      position: relative;
      .on-title {
        font-size: 16px;
        font-weight: 600;
      }
      .on-icon {
        width: vw(40);
        position: absolute;
        top: 2px;
        right: 8px;
      }
      .on-more-imgs-region {
        width: 100%;
        box-sizing: border-box;
        overflow-x: auto;
      }
      .on-more-imgs {
        width: fit-content;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        margin-top: 9px;
        .img-item {
          width: 87px;
          height: 87px;
          object-fit: cover;
          border-radius: 6px;
          margin-right: 8px;
        }
      }
    }
    .on-yys {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding: 0 20px;
      position: relative;
      margin-top: 20px;
      .y-img {
        width: 42px;
        height: 43px;
        background: #e5e5e5;
        border-radius: 12px;
      }
      .y-name {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        margin-left: 10px;
      }
      .on-yys-icon {
        width: 51px;
        position: absolute;
        right: 14px;
      }
    }
    .on-more-title {
      width: 100%;
      box-sizing: border-box;
      height: 31px;
      background: rgba($color: #6236ff, $alpha: 0.08);
      display: flex;
      align-items: center;
      padding-left: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      margin-top: 20px;
    }
    .on-more-text {
      font-size: 12px;
      font-weight: 400;
      color: #000000;
      line-height: 20px;
      margin-top: 15px;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .on-more-cent {
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;
      // padding-right: 22px;
      margin-top: 15px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 20px;
      color: rgba($color: #000, $alpha: 0.7);
      word-break: break-all;
      span {
        color: rgba($color: #6236ff, $alpha: 0.7);
        font-weight: 600;
      }
      .c-item {
        margin-bottom: 4px;
      }
    }
  }
  .card-only-deduct {
    .on-top {
      background: linear-gradient(169deg, #e7e0ff 0%, #f9f9ff 100%);
    }
  }
}
</style>
